/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dismiss_BannerInputs */

const en_dismiss_banner = /** @type {(inputs: Dismiss_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

const es_dismiss_banner = /** @type {(inputs: Dismiss_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar aviso`)
};

/**
* | output |
* | --- |
* | "Dismiss banner" |
*
* @param {Dismiss_BannerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dismiss_banner = /** @type {((inputs?: Dismiss_BannerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dismiss_BannerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dismiss_banner(inputs)
	return es_dismiss_banner(inputs)
});